// `/` i nieznane adresy → strona startowa (/home). Jest dla KAŻDEGO konta (tabela
// i terminarz to słowniki wspólne) — co jeszcze na niej stoi, dobiera sama strona
// wg uprawnień; bez sesji przy włączonej fladze bramka AppShell pokaże logowanie.

import { Navigate } from 'react-router-dom'

import { DEFAULT_LANDING } from '../../lib/access'

export function HomeRedirect() {
  return <Navigate to={DEFAULT_LANDING} replace />
}
